import React from "react";
import { Layout, Col, Row, Tabs } from "antd";
import { URL } from "../00_Nav/url";
// component
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import SectionTitle from "../../component/section_title";
import BranchShopAdd from "../02_Branch_Tab_Shop/branch_shop_add";
// redux

const { Content } = Layout;
const { TabPane } = Tabs;

const BranchTabAdd = () => {
  // -------------------------- VAR --------------------------
  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Branchs", url: URL.home },
    { title: "Add", url: null },
  ];
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION --------------------------
  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    return (
      <Row
        style={{ marginTop: 20 }}
        justify="end"
        align="middle"
        gutter={[16, 16]}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <Tabs defaultActiveKey="1" type="card" size="large">
            <TabPane tab="Shop" key="1">
              <BranchShopAdd />
            </TabPane>
            <TabPane tab="Payment" disabled={true} key="2"></TabPane>
            <TabPane tab="Staff" disabled={true} key="3"></TabPane>
            <TabPane tab="Access" disabled={true} key="4"></TabPane>
            <TabPane tab="Voucher" disabled={true} key="5"></TabPane>
          </Tabs>
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------

  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        {renderBody()}
      </Content>
    </Layout>
  );
};

export default BranchTabAdd;
